import { post2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import useOnboardingsQuery from "@/shared/queries/onboarding/useOnboardingsQuery";
import { useMutation } from "@tanstack/react-query";

const useOnboardingInit = () => {
  const { refetch } = useOnboardingsQuery();

  return useMutation({
    mutationFn: (branchId: number) =>
      post2(`/internal/secure/pos/v1/add/activation/activities/${branchId}`),
    onSuccess: () => {
      refetch();
    },
  });
};

export default useOnboardingInit;
